import { default as Component } from './ComponentList';

export { Component };



// WEBPACK FOOTER //
// src/modules/screens/settings/StickyAgent/components/index.js